var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 42,
    viewBox: "0 0 38 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,9h34",
    transform: "translate(0 1.6)",
    fill: "none",
    stroke: "#e20613",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.944,10.6V37.2A3.789,3.789,0,0,1,30.167,41H11.278A3.789,3.789,0,0,1,7.5,37.2V10.6m5.667,0V6.8A3.789,3.789,0,0,1,16.944,3H24.5a3.789,3.789,0,0,1,3.778,3.8v3.8",
    transform: "translate(0.778 0)",
    fill: "none",
    stroke: "#e20613",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,16.5V27.9",
    transform: "translate(2.722 3.6)",
    fill: "none",
    stroke: "#e20613",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,16.5V27.9",
    transform: "translate(4.278 3.6)",
    fill: "none",
    stroke: "#e20613",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReset);
export default __webpack_public_path__ + "static/media/icon-reset.48fa2ebc.svg";
export { ForwardRef as ReactComponent };